var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCouponVoided(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ticket_zone/coupon_voided_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/ticket_zone/coupon_voided_24px_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/ticket_zone/coupon_voided_24px_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 3C1.98497 3 1 4.00736 1 5.25V9.75C2.221 9.75 3.2 10.7625 3.2 12C3.2 13.2426 2.21503 14.25 1 14.25V18.75C1 19.9926 1.98497 21 3.2 21H13.0709C13.0242 20.6734 13 20.3395 13 20C13 18.8813 13.2624 17.8239 13.7291 16.886C13.3575 16.5651 13.1224 16.0906 13.1224 15.5612C13.1224 14.5947 13.9059 13.8112 14.8724 13.8112C15.3118 13.8112 15.7133 13.973 16.0206 14.2404C17.1505 13.4582 18.5217 13 20 13C21.0736 13 22.0907 13.2417 23 13.6736V12V9.75V5.25C23 4.00125 22.01 3 20.8 3H3.2ZM9.77042 7C8.80392 7 8.02042 7.7835 8.02042 8.75C8.02042 9.7165 8.80392 10.5 9.77042 10.5C10.7369 10.5 11.5204 9.7165 11.5204 8.75C11.5204 7.7835 10.7369 7 9.77042 7ZM17.2041 8.66249L8.43878 17.0207L7 15.6488L15.7653 7.29053L17.2041 8.66249Z",
    fill: "#5D6B72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8631 21.3018L22.1766 23.5725L23.7153 22.0623L21.4018 19.7916L23.7262 17.5209L22.1766 16L19.8631 18.2814L17.5496 16.0107L16.0109 17.5209L18.3244 19.7916L16 22.0623L17.5496 23.5833L19.8631 21.3018Z",
    fill: "#D0021B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 3,
    width: 23,
    height: 21
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/ticket_zone/coupon_voided_24px_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/ticket_zone/coupon_voided_24px_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 3C1.98497 3 1 4.00736 1 5.25V9.75C2.221 9.75 3.2 10.7625 3.2 12C3.2 13.2426 2.21503 14.25 1 14.25V18.75C1 19.9926 1.98497 21 3.2 21H14.083C14.0284 20.6748 14 20.3407 14 20C14 19.0273 14.2315 18.1087 14.6423 17.2962C13.7846 17.1835 13.1224 16.4497 13.1224 15.5612C13.1224 14.5947 13.9059 13.8112 14.8724 13.8112C15.6741 13.8112 16.3498 14.3502 16.557 15.0855C17.5316 14.4015 18.7189 14 20 14C21.0929 14 22.1175 14.2922 23 14.8027V14.25V12V9.75V5.25C23 4.00125 22.01 3 20.8 3H3.2ZM9.77042 7C8.80392 7 8.02042 7.7835 8.02042 8.75C8.02042 9.7165 8.80392 10.5 9.77042 10.5C10.7369 10.5 11.5204 9.7165 11.5204 8.75C11.5204 7.7835 10.7369 7 9.77042 7ZM17.2041 8.66249L8.43878 17.0207L7 15.6488L15.7653 7.29053L17.2041 8.66249Z",
    fill: "#5D6B72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.8631 21.3018L22.1766 23.5725L23.7153 22.0623L21.4018 19.7916L23.7262 17.5209L22.1766 16L19.8631 18.2814L17.5496 16.0107L16.0109 17.5209L18.3244 19.7916L16 22.0623L17.5496 23.5833L19.8631 21.3018Z",
    fill: "#D0021B"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponVoided);
export default __webpack_public_path__ + "static/media/CouponVoided.8eb46c71.svg";
export { ForwardRef as ReactComponent };